module.exports = __webpack_public_path__ + "static/img/cjgyTu4@2x.c9bfd020.png";